import type { Filters } from "@/services/api/types";

// A partner contact participates through the partner-contact arrays; the
// dynamically-keyed field holds only the record's primary partner person.
const partnerContactArrayClauses = (entityId: string): Filters[] => [
  { manuallyAddedPartnerContacts: { contains: entityId } },
  { automaticallyAddedPartnerContacts: { contains: entityId } }
];

export const partnerContactDealsFilter = (
  entityId: string,
  primaryPartnerContactKey?: string
): Filters => ({
  $or: [
    ...(primaryPartnerContactKey
      ? [{ [primaryPartnerContactKey]: [entityId] }]
      : []),
    ...partnerContactArrayClauses(entityId)
  ]
});

// Contracts carry no primary partner-contact field, so the arrays are all of it.
export const partnerContactContractsFilter = (entityId: string): Filters => ({
  $or: partnerContactArrayClauses(entityId)
});
